import React, { useState, useEffect } from 'react';
import {
  Card, CardContent, Typography, Box, TextField,
  Button, MenuItem, CircularProgress, Alert
} from '@mui/material';
import { groupService } from '../../services/groupService';

const GroupDetail = ({ group, projectId, onSaveSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    status: 'active'
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (group) {
      setFormData({
        name: group.name || '',
        status: group.status || 'active'
      });
    } else {
      setFormData({ name: '', status: 'active' });
    }
  }, [group]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!formData.name.trim()) {
      setError('Name is required');
      return;
    }

    try {
      setSaving(true);
      setError(null);
      const payload = { ...formData, project: projectId };

      let savedGroup;
      if (group && group._id) {
        savedGroup = await groupService.updateGroup(group._id, payload);
      } else {
        savedGroup = await groupService.createGroup(payload);
      }

      if (onSaveSuccess) onSaveSuccess(savedGroup, !group?._id);
    } catch (err) {
      console.error('Error saving group:', err);
      setError(err.response?.data?.message || 'Failed to save group');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card sx={{ height: '100%', overflowY: 'auto' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {group?._id ? `Edit ${group.name}` : 'Add New Group'}
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <TextField
            required
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            size="small"
          />

          <TextField
            fullWidth
            select
            label="Status"
            name="status"
            value={formData.status}
            onChange={handleChange}
            size="small"
          >
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </TextField>

          <Button
            variant="contained"
            color="success"
            onClick={handleSave}
            disabled={saving}
            sx={{ alignSelf: 'flex-start' }}
          >
            {saving ? <CircularProgress size={24} color="inherit" /> : 'Save'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default GroupDetail;
